export default "__VITE_ASSET__ezKrOTJv__"